<template>
  <div>
    <div class="container_sub_grupo" v-for="(data,index) in dadosSubGrupo" v-bind:key="index">
        <div class="header_sub_grupo" v-if="preRequisito === true">

            <div class="button-selecionado">
                <div style="margin: 0 0 0 0.6rem;">
                    <div class="button-lista"  :id="data.etapaId"  @click="SelecionarEtapa(data.etapaId)"><i class="fas fa-check" style="color: rgb(19, 59, 26); font-size: 9px;" v-if="data.checkTodosItens === true"></i></div>
                </div>
            </div>
            <div class="font">{{ data.nivelPrioridadeEtapa === undefined ? data.descricaoEtapa : data.nivelPrioridadeEtapa + ' - ' + data.descricaoEtapa }}</div>
        </div>
        <div class="add_pergunta">
            <div class="font_add_pergunta" @click="abrirModalPergunta(false, data.etapaId, null, null, null, data.adicao, null, null, null, data.metadado, data)">
                <i class="fas fa-plus" ></i> ADICIONAR PERGUNTA
            </div>
        </div>
        <div class="container_perguntas"  v-for="(item,index) in data.itens" v-bind:key="index">
          <div class="container-perguntas-item pl-4">
            <div class="button-selecionado">
                <div v-if="item.edicao !== true">
                    <div class="button-lista" :id="item.perguntaId"  @click="SelecionarPergunta(item, data.etapaId, null)"><i class="fas fa-check" style="color: rgb(19, 59, 26); font-size: 9px;" v-if="item.check === true"></i></div>
                </div>
            </div>
            <img  v-if="item.tipoCampo !== 10 && item.tipoCampo !== null && item.tipoCampo !== undefined" :src="item.tipoCampo == 0 ? imgTexto : item.tipoCampo == 1 ? imgNumero : item.tipoCampo == 2 ? imgImagem : item.tipoCampo == 3 ? imgData : item.tipoCampo == 4 ? imgAnexo : item.tipoCampo == 5 ? imgSelecaoTexto : item.tipoCampo == 6 ? imgDocs : imgAvaliacao"  v-b-tooltip.hover :title="item.tipoCampo == 0 ? 'Campo Texto' : item.tipoCampo == 1 ? 'Campo Número' : item.tipoCampo == 2 ? 'Campo Foto' : item.tipoCampo == 4 ? 'Alternativas com Imagens' : item.tipoCampo == 5 ? 'Alternativas' : item.tipoCampo == 6 ? 'Anexo' :'Campo Avaliação'">
            <div class="pergunta">
              <div class="font">
                {{item.nivelPrioridadePergunta === null ? item.descricaoPergunta : item.nivelPrioridadePergunta + ' - ' +  item.descricaoPergunta}}
                <span v-if="item.opcional === false" style="color: #540000; font-weight: bold;" v-b-tooltip.hover title="Item obrigatório"> *</span>
              </div>
              <div class="tag" v-if="item.edicao === true">
                <div class="tag_identificacao" :style="{'background-color': item.colorStatus, 'color': item.colorFonte}"> {{ item.descricaoEdicao }}</div>
              </div>
            </div>
            <div class="edicao">
                <div class="icon_container" v-if="item.exclusao !== true">
                  <i class="fas fa-pen" v-b-tooltip.hover :title="'Editar Pergunta'"  @click="abrirModalPergunta(true, data.etapaId, item.descricaoPergunta, item.perguntaId, item.tipoCampo, data.adicao, item.itensSelecaoImagem, item.multiplos, item, data.metadado, data)"></i>
                </div>
                <div class="icon_container" v-if="item.exclusao == true || item.adicao == true" >
                  <i class="fas fa-times" style="color: rgb(136, 22, 22); font-size: 14px" v-b-tooltip.hover :title="item.exclusao == true ? 'Remover Edições do tipo Exclusão' : 'Remover Novo Item'" v-if="item.exclusaoEtapa === false" @click="RemoverEdicao(data.etapaId, item.perguntaId)"></i>
                </div>
                <div class="icon_container"  @click="abrirCollapse(item.perguntaId, item.tipoCampo, item)" v-if="item.tipoCampo === 4 || item.tipoCampo === 5">
                  <i v-if="!isOpen(item.perguntaId)" class="fas fa-angle-down arrow_angel" v-b-tooltip.hover :title="'Abrir lista de opções'"></i>
                  <i v-else class="fas fa-angle-up arrow_angel" v-b-tooltip.hover :title="'Fechar lista de opções'"></i>
                </div>
            </div>
          </div>
          <div class="contentOpcao" :class="{ show: isOpen(item.perguntaId) }" v-if="item.tipoCampo === 5">
            <div class="container-perguntas-selecao">
              <div class="container-itens-selecao-titulo">
                <div style="margin-left: 2rem;">Opções</div>
              </div>
              <div class="container-itens-selecao" v-for="(selecao, index) in item.itensSelecaoImagem" :key="index">
                <div class="titulo-img" style="margin-left: 2rem;">{{ index + ' ) ' + selecao.descricaoPerguntaSelecaoImagem }}</div>
              </div>
            </div>
          </div>
          <div class="contentOpcao" :class="{ show: isOpen(item.perguntaId) }" v-if="item.tipoCampo === 4">
            <div class="container-itens-selecao-img">
              <div class="container-itens-selecao-img" v-for="(selecao, index) in item.itensSelecaoImagem" :key="index">
                <b-skeleton-img animation="wave" class="icone-img" v-if="selecao.base64 === ''"></b-skeleton-img>
                <div v-if="selecao.base64 !== '' && selecao.exclusao === false">
                  <div class="container-imgs">
                    <img  :src="selecao.file64 === undefined ? 'data:image/jpeg;base64,' + selecao.base64 : selecao.file64" class="icone-img"/>
                  </div>
                  <div class="titulo-img">{{ index + ' ) ' + selecao.descricaoPerguntaSelecaoImagem }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <addquestion
          ref="modalPerguntas"
          @tabelaNovaPergunta="tabelaNovaPergunta"
          @addNovaPergunta="addNovaPergunta"
          @addNovaPerguntaGrupo="addNovaPerguntaGrupo"
          @editarPergunta="editarPergunta"
          @addNovaPerguntaParaSubEtapa="addNovaPerguntaParaSubEtapa"
          @addNovaPerguntaEtapaSubCriada="addNovaPerguntaEtapaSubCriada"
          @editarNovaPerguntaParaSubEtapa="editarNovaPerguntaParaSubEtapa"
          @editarEmMemoriaNovaPerguntaParaEtapa="editarEmMemoriaNovaPerguntaParaEtapa"
          @editarNovaPerguntaEtapaSubCriada="editarNovaPerguntaEtapaSubCriada"
          @addNovaPerguntaImagem="addNovaPerguntaImagem"
          @EditarNovaPerguntaImagem="EditarNovaPerguntaImagem"
          @excluirImagem="excluirImagem"
          @removerImagemNova="removerImagemNova"
          @editarImagemNova="editarImagemNova"
          :pergunta="pergunta"
          :equipamento="equipamento"
          :perguntaId="perguntaId"
          :preRequisito="preRequisito"
          :grupoId="etapaGrupoSelecionadoId"
          :etapaCriada="etapaCriada"
          :etapaId="etapaId"
          :metadado="tipometadado">
        </addquestion>

        <deleteQuestion
          ref="modal_Excluir"
          :subGrupo="subGrupo"
          :templateid="templateid"
          @deleteItensSubGrupo="deleteItensSubGrupo">
        </deleteQuestion>

    </div>

  </div>
</template>

<script>
import SubGroupDetail from './SubGroupDetail'
export default SubGroupDetail
</script>
  <style scoped>
  .titulo-img {
    font: normal normal bold 13px / 24px Segoe UI;
    color: #808080;
    margin-top: 0.5rem;
    width: 100%;
  }
  .container-imgs {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .icone-img {
    height: 12rem;
    border-radius: 10px;
    width: 12rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .arrow_angel{
      font-size: 20px;
      color: rgb(100, 100, 100);
  }
  .img_tipo_campo {
    width: 25px;
  }
  .icon_container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tag{
    display: flex;
    justify-content: initial;
    align-content: center;
    align-items: center;
    width: 35%;
    padding: 0 0.3rem 0 0.8rem;
  }
  .tag_identificacao{
    width: fit-content;
    height: 1.6rem;
    text-align: center;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font: normal normal 600 10px / 24px Segoe UI;
    padding: 0 5px 0 5px;
    font-weight: bold;
  }
  .font_add_pergunta {
    font: normal normal 600 11px / 24px Segoe UI;
    color: #1C6228;
    gap: 0.5rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .font{
    font: normal normal 600 12px / 24px Segoe UI;
    width: fit-content;
    padding-right: 1rem;
  }
  .container_sub_grupo {
    width: 100%;
    height: fit-content;
  }
  .header_sub_grupo {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: initial;
    gap: 0.3rem;
    background-color: #F4F4F4;
  }
  .container_perguntas {
    border-bottom: 1px solid #E1E1E1
  }
  .container-perguntas-item {
    padding: 10px;
    display: flex;
    gap: 0.5rem;
  }
  .container-perguntas-selecao {
    border-top: 1px solid #E1E1E1;
  }
  .pergunta{
    width: 100%;
    display: flex;
  }
  .add_pergunta {
    width: 100%;
    height: fit-content;
    padding: 5px;
    border-left: 2px dashed #d2d2d2;
    border-right: 2px dashed #d2d2d2;
    border-bottom: 2px dashed #d2d2d2;
    background-color: #fff;
  }
  .edicao {
    gap: 1rem;
    width: fit-content;
    display: flex;
    justify-content: end;
  }
  .margin-r {
    margin-right: 1rem;
  }

  /* estilização checkbox */
  .button-selecionado{
    display: flex;
    width: 2%;
    align-items: center;
    justify-content: center;
  }

  .button-lista{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    background-color: white;
    border-radius: 12%;
    border: 1px solid #c4c4c4;
  }
  .button-lista.clicked {
    background-color: rgb(203, 233, 207);
    border: 1px solid rgb(81 134 91)
  }

  /* Collapse opções da pergunta */
  .collapsible {
  background-color: #777;
  color: white;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.active, .collapsible:hover {
  background-color: #555;
}

.contentOpcao {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.8s ease, padding 0.8s ease;
}

.contentOpcao.show {
  max-height: fit-content;
  width: 100%;
  line-height: 20px;
}

.container-itens-selecao {
  padding: 10px;
  width: 100%;
  border-bottom: 1px solid #E1E1E1;
}
.container-itens-selecao-img{
  padding: 10px;
  column-gap: 5rem;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.container-itens-selecao-titulo {
  padding: 10px;
  border-bottom: 1px solid #E1E1E1;
  font: normal normal bold 14px / 24px Segoe UI;
  color: #1C6228;
}

 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/SubGroupDetail/SubGroupDetail.vue